import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import * as headerConfig from '@unitedtraders/header-microfrontend';
import { Header as MicroHeader } from '@unitedtraders/header-microfrontend';
import { actions, AuthModalTab } from 'shared/actions/app';
import { useAuthenticationStatus } from 'shared/hooks/user';
import { KeycloakContext } from 'init/App';
import { root as configSelector } from 'shared/selectors/config';
import { useBetaVersionRedirect } from 'hooks/useBetaVersionRedirect';
import { useLoginWith2FARecomendation } from 'hooks/useLoginWith2FARecomendation';

import './index.scss';

interface Props {
  headerView?: 'black' | 'white';
}

export const Header: React.FC<Props> = ({ headerView }) => {
  const isAuthorized = useAuthenticationStatus();

  const {
    i18n: { language },
  } = useTranslation();

  const config = useSelector(configSelector);

  const { hideRecomendation, isRecomendationVisible } = useLoginWith2FARecomendation();

  const dispatch = useDispatch();

  const goTo = useBetaVersionRedirect();

  const showAuthModal = (tab: AuthModalTab) =>
    dispatch(actions.showAuthModal(tab, 'mainMenu', 'desktopMainMenuRegistration'));

  const keycloak = React.useContext(KeycloakContext)!;

  const location = useLocation();

  const props: headerConfig.OwnProps = {
    navigationActiveItem: getActiveMenu(location.pathname),
    isAuthorized,
    isSSR: __ISSERVER__,
    locale: language,
    // @ts-ignore
    featureFlags: {},
    getTokens: () => keycloak.getTokens(),
    onLogin: () => showAuthModal('signin'),
    onRegistration: () => showAuthModal('signup'),
    openSideMenu: () => dispatch(actions.toggleSidemenu(true)),
    openDepositModal: () => dispatch(actions.showDepositModal({ value: 0, currency: 'USD' })),
    openWithdrawModal: () => dispatch(actions.showWithdrawModal()),
    view: headerView,
    navigateTo: goTo,

    appConfig: {
      graphqlGateway: {
        url: config.graphqlGateway.url,
      },
    },
    // @ts-ignore
    loginWith2FARecomendation: {
      isVisible: isRecomendationVisible,
      hide: hideRecomendation,
    },
  };

  return (
    <div className="header-external">
      <MicroHeader {...props} />
    </div>
  );
};

function getActiveMenu(pathname: string): headerConfig.OwnProps['navigationActiveItem'] {
  if (pathname.startsWith('/investments/open-investment')) {
    return 'portfolio';
  }

  if (pathname.startsWith('/investments')) {
    return 'ideas';
  }

  if (pathname.startsWith('/how-it-works')) {
    return 'howItWorks';
  }

  return;
}
